var SELF_ID_SCREENS_IN_ORDER = [
    '/pii-data/tel',
    '/pii-data/dob',
    '/pii-data/ssn4',
    '/pii-data/review',
];
var piiNavigation = [
    {
        route: '/pii-data/tel',
        field: 'mobile_phone_number',
    },
    {
        route: '/pii-data/dob',
        field: 'date_of_birth',
    },
    {
        route: '/pii-data/ssn4',
        field: 'social_security_number_last_four',
    },
];
export function getSelfIdNextRoute(linkTokenPayload, currentRoute) {
    var _a, _b;
    if (currentRoute === void 0) { currentRoute = null; }
    var screensToDisplay = piiNavigation.filter(function (item) { var _a; return (_a = linkTokenPayload.missingUserAuthenticationFields) === null || _a === void 0 ? void 0 : _a.includes(item.field); });
    if (!currentRoute) {
        return screensToDisplay[0].route;
    }
    var index = screensToDisplay.findIndex(function (item) { return item.route === currentRoute; });
    // this should never happen
    if (index === -1 || screensToDisplay.length === 0) {
        return null;
    }
    return ((_b = (_a = screensToDisplay[index + 1]) === null || _a === void 0 ? void 0 : _a.route) !== null && _b !== void 0 ? _b : SELF_ID_SCREENS_IN_ORDER[SELF_ID_SCREENS_IN_ORDER.length - 1] // review screen
    );
}
export default piiNavigation;
